import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const isCalculatePage = location.pathname === '/calculate/stackreport';

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className={`bg-green-600 p-4 text-white ${isCalculatePage ? '' : 'fixed'} w-full top-0 z-10`}>
            <div className="container mx-auto flex justify-between items-center">
                <div className="text-2xl font-bold"><a href="/">EPTech</a></div>
                <div className="hidden lg:flex space-x-4">
                    <Link to="/" className="hover:text-green-300">Home</Link>
                    <Link to="/about" className="hover:text-green-300">About</Link>
                    <Link to="/calculate" className="hover:text-green-300">Calculate</Link>
                    <Link to="/contact" className="hover:text-green-300">Contact</Link>
                </div>
                <div className="lg:hidden">
                    <button onClick={toggleMenu} className="text-white focus:outline-none">
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            {isOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                            )}
                        </svg>
                    </button>
                </div>
            </div>
            {isOpen && (
                <div className="lg:hidden bg-green-600 w-full py-2 absolute top-16 right-0 text-center">
                    <Link to="/" className="block py-2 hover:text-green-300">Home</Link>
                    <Link to="/about" className="block py-2 hover:text-green-300">About</Link>
                    <Link to="/calculate" className="block py-2 hover:text-green-300">Calculate</Link>
                    <Link to="/contact" className="block py-2 hover:text-green-300">Contact</Link>
                </div>
            )}
        </nav>
    );
};

export default Navbar;